// src/screenshot.ts
type ScreenshotOptions = {
    selector: string;
    maxBytes: number;
    mime: 'image/jpeg' | 'image/png';
    quality: number;
    minQuality: number;
};

const estimateBytesFromDataUrl = (dataUrl: string) => {
    const base64 = dataUrl.split(',')[1] || '';
    return Math.ceil((base64.length * 3) / 4);
};

const toDataUrlFromCanvas = (canvas: HTMLCanvasElement, options: ScreenshotOptions) => {
    let q = options.quality;
    let dataUrl = canvas.toDataURL(options.mime, q);
    let bytes = estimateBytesFromDataUrl(dataUrl);
    while (bytes > options.maxBytes && q > options.minQuality) {
        q = Math.max(options.minQuality, q - 0.1);
        dataUrl = canvas.toDataURL(options.mime, q);
        bytes = estimateBytesFromDataUrl(dataUrl);
    }
    return bytes <= options.maxBytes ? dataUrl : undefined;
};

const elementToCanvas = (el: Element) => {
    if (el instanceof HTMLCanvasElement) return el;
    if (el instanceof HTMLImageElement) {
        const canvas = document.createElement('canvas');
        const w = el.naturalWidth || el.width;
        const h = el.naturalHeight || el.height;
        if (!w || !h) return undefined;
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) return undefined;
        ctx.drawImage(el, 0, 0);
        return canvas;
    }
    if (el instanceof HTMLVideoElement) {
        const canvas = document.createElement('canvas');
        const w = el.videoWidth || el.clientWidth;
        const h = el.videoHeight || el.clientHeight;
        if (!w || !h) return undefined;
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) return undefined;
        ctx.drawImage(el, 0, 0);
        return canvas;
    }
    return undefined;
};

export const captureScreenshotFromTag = (options: ScreenshotOptions) => {
    if (typeof document === 'undefined') return undefined;
    const target = document.querySelector(options.selector);
    if (!target) return undefined;
    const canvas = elementToCanvas(target);
    if (!canvas) return undefined;
    return toDataUrlFromCanvas(canvas, options);
};

export type { ScreenshotOptions };
